module.exports = __webpack_public_path__ + "img/2021_11_dande_hikono_fin_web.a3c5953f.png";